import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _excluded = ["className", "prefixCls"];
var _templateObject;
import React from 'react';
import { Warpper, WarpperOverflow } from "./components/Warpper.js";
import { ToolBar } from "./components/toolbar/index.js";
import { Provider } from "./store/content.js";
import { ProviderSetting } from "./store/setting.js";
import EditorContainer from "./components/editor/index.js";
import { createGlobalStyle } from 'styled-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var GlobalStyle = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  [data-color-mode*='dark'], [data-color-mode*='dark'] .w-code-image-color {\n    --color-ci-bg: #2f2f2fd9;\n    --color-ci-btn-bg: #5a5a5ad9;\n    --color-ci-btn-hover-bg: #a1a1a1d9;\n  }\n  [data-color-mode*='light'], [data-color-mode*='light'] .w-code-image-color {\n    --color-ci-bg: #ffffffd9;\n    --color-ci-btn-bg: #e4e4e4d9;\n    --color-ci-btn-hover-bg: #a1a1a1d9;\n  }\n"])));
export default function CodeImage(props) {
  if (props === void 0) {
    props = {};
  }
  var {
      className,
      prefixCls = 'w-code-image'
    } = props,
    others = _objectWithoutPropertiesLoose(props, _excluded);
  var cls = [className, prefixCls, 'w-code-image-color'].filter(Boolean).join(' ');
  return /*#__PURE__*/_jsx(ProviderSetting, {
    children: /*#__PURE__*/_jsxs(Provider, {
      children: [/*#__PURE__*/_jsx(GlobalStyle, {}), /*#__PURE__*/_jsx(ToolBar, {
        className: "w-code-image-color"
      }), /*#__PURE__*/_jsx(WarpperOverflow, {
        className: cls,
        children: /*#__PURE__*/_jsx(Warpper, _extends({}, others, {
          children: /*#__PURE__*/_jsx(EditorContainer, {})
        }))
      })]
    })
  });
}